export default {
  // 获取是否为微信浏览器环境
  isWxBrowser () {
    /*
     * 通过正则表达式匹配ua中是否含有MicroMessenger字符串
     */
    const ua = window.navigator.userAgent.toLowerCase()
    return ua.includes('micromessenger')
  }
}
